/* ============================================================
   Kordello CUSTOM THEME - JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  // --- Mobile Menu ---
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-menu-overlay');
  const menuClose = document.querySelector('.mobile-menu__close');

  function openMobileMenu() {
    mobileMenu && mobileMenu.classList.add('open');
    mobileOverlay && mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu && mobileMenu.classList.remove('open');
    mobileOverlay && mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  menuToggle && menuToggle.addEventListener('click', openMobileMenu);
  menuClose && menuClose.addEventListener('click', closeMobileMenu);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileMenu);

  // Mobile menu section toggles
  document.querySelectorAll('.mobile-menu__section-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      this.classList.toggle('open');
      var list = this.nextElementSibling;
      if (list) list.classList.toggle('open');
    });
  });

  // --- Product Image Gallery ---
  var mainImage = document.getElementById('product-main-image');
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var newSrc = this.getAttribute('data-image');
      if (mainImage && newSrc) {
        mainImage.src = newSrc;
        document.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });

  // --- Product Tabs ---
  document.querySelectorAll('.product-tabs__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tabId = this.getAttribute('data-tab');
      // Remove active from all buttons and panels
      document.querySelectorAll('.product-tabs__btn').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.product-tabs__panel').forEach(function(p) { p.classList.remove('active'); });
      // Activate clicked
      this.classList.add('active');
      var panel = document.getElementById('tab-' + tabId);
      if (panel) panel.classList.add('active');
    });
  });

  // --- Variant Selector ---
  var variantSelect = document.getElementById('variant-select');
  var priceEl = document.getElementById('product-price');
  var variantIdInput = document.getElementById('product-variant-id');
  var submitBtn = document.querySelector('.product-form__submit');

  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      var selected = this.options[this.selectedIndex];
      var price = selected.getAttribute('data-price');
      var available = selected.getAttribute('data-available') === 'true';

      if (variantIdInput) variantIdInput.value = this.value;
      if (priceEl && price) priceEl.textContent = price;
      if (submitBtn) {
        if (available) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'ADD TO CART';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = 'SOLD OUT';
        }
      }
    });
  }

  // --- Quantity Buttons ---
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus = document.getElementById('qty-plus');
  var qtyInput = document.getElementById('product-qty');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // --- Collection Sort ---
  var sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // --- Collection Sidebar Toggle (Mobile) ---
  var filterToggle = document.getElementById('filter-toggle');
  var sidebar = document.getElementById('collection-sidebar');
  if (filterToggle && sidebar) {
    filterToggle.addEventListener('click', function() {
      sidebar.classList.toggle('open');
      if (sidebar.classList.contains('open')) {
        // Add close button if not exists
        if (!sidebar.querySelector('.sidebar-close')) {
          var closeBtn = document.createElement('button');
          closeBtn.className = 'sidebar-close btn btn--primary btn--full';
          closeBtn.textContent = 'CLOSE FILTERS';
          closeBtn.style.marginTop = '20px';
          closeBtn.addEventListener('click', function() {
            sidebar.classList.remove('open');
          });
          sidebar.appendChild(closeBtn);
        }
      }
    });
  }

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});


/* ============================================
   MEGA MENU JAVASCRIPT
   ============================================ */
document.addEventListener('DOMContentLoaded', function() {
  // Mega menu image preview on hover
  document.querySelectorAll('.mega-sidebar-link, .mega-grid-link').forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      var megaMenu = this.closest('.mega-menu');
      if (!megaMenu) return;
      
      var imgSrc = this.getAttribute('data-img');
      var label = this.getAttribute('data-label') || this.textContent.trim();
      var previewImg = megaMenu.querySelector('.mega-preview-img img');
      var previewLabel = megaMenu.querySelector('.mega-preview-label');
      var previewCta = megaMenu.querySelector('.mega-preview-cta');
      
      if (imgSrc && previewImg) {
        previewImg.src = imgSrc;
        previewImg.alt = label;
      }
      if (previewLabel) {
        previewLabel.textContent = label;
      }
      
      // Highlight active sidebar link
      if (this.classList.contains('mega-sidebar-link')) {
        megaMenu.querySelectorAll('.mega-sidebar-link').forEach(function(s) {
          s.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });

  // Set first sidebar link as active by default
  document.querySelectorAll('.mega-menu').forEach(function(menu) {
    var firstLink = menu.querySelector('.mega-sidebar-link');
    if (firstLink) firstLink.classList.add('active');
  });
});

/* Product Tabs */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-tabs__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tab = this.getAttribute('data-tab');
      document.querySelectorAll('.product-tabs__btn').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.product-tabs__content').forEach(function(c) { c.classList.remove('active'); });
      this.classList.add('active');
      document.querySelector('[data-tab-content="' + tab + '"]').classList.add('active');
    });
  });

  /* Mega menu image swap on hover */
  document.querySelectorAll('.mega-panel__link').forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      var img = this.getAttribute('data-img');
      if (img) {
        var panel = this.closest('.mega-panel');
        var imgEl = panel.querySelector('.mega-panel__image img');
        if (imgEl) imgEl.src = img;
      }
    });
  });

  /* Mega menu click toggle for touch devices */
  document.querySelectorAll('.hdr-nav__item.has-mega > .hdr-nav__link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      if (window.innerWidth > 768) {
        var parent = this.parentElement;
        var isActive = parent.classList.contains('active');
        document.querySelectorAll('.hdr-nav__item.has-mega').forEach(function(item) {
          item.classList.remove('active');
        });
        if (!isActive) {
          e.preventDefault();
          parent.classList.add('active');
        }
      }
    });
  });

  /* Close mega menu when clicking outside */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.hdr-nav__item.has-mega')) {
      document.querySelectorAll('.hdr-nav__item.has-mega').forEach(function(item) {
        item.classList.remove('active');
      });
    }
  });

  /* Wrap tables in scroll wrapper for mobile */
  document.querySelectorAll('.product-desc table').forEach(function(table) {
    if (!table.parentElement.classList.contains('table-scroll-wrapper')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'table-scroll-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  });
});


/* ============================================================
   MEGA MENU - Hover image switching
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  // Mega menu hover image switching
  document.querySelectorAll('.mega-panel__link[data-img]').forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      var img = this.getAttribute('data-img');
      if (img) {
        var panel = this.closest('.mega-panel');
        var imgEl = panel.querySelector('.mega-panel__image img');
        if (imgEl) {
          imgEl.style.opacity = '0';
          setTimeout(function() {
            imgEl.src = img;
            imgEl.style.opacity = '1';
          }, 150);
        }
      }
    });
  });

  // Product tabs
  document.querySelectorAll('.product-tabs__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tab = this.getAttribute('data-tab');
      // Remove active from all buttons and contents
      document.querySelectorAll('.product-tabs__btn').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.product-tabs__content').forEach(function(c) { c.classList.remove('active'); });
      // Add active to clicked
      this.classList.add('active');
      var content = document.querySelector('[data-tab-content="' + tab + '"]');
      if (content) content.classList.add('active');
    });
  });

  // Mobile menu toggle for mega items
  document.querySelectorAll('.hdr-nav__item.has-mega').forEach(function(item) {
    item.addEventListener('click', function(e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        this.classList.toggle('mega-open');
      }
    });
  });
});


/* Mega menu image preview on hover */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.mega-cat-link[data-img]').forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      var img = this.getAttribute('data-img');
      var label = this.getAttribute('data-label') || this.querySelector('.mega-cat-name').textContent;
      var panel = this.closest('.mega-menu');
      if (panel) {
        var previewImg = panel.querySelector('.mega-preview-img img');
        var previewLabel = panel.querySelector('.mega-preview-label');
        if (previewImg) previewImg.src = img;
        if (previewLabel) previewLabel.textContent = label;
      }
    });
  });
});


/* ============================================================
   MEGA MENU - JavaScript Toggle (hover on desktop, click on mobile)
   ============================================================ */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var megaItems = document.querySelectorAll('.nav-item.has-mega');
    var closeTimeout = null;

    function closeAll() {
      megaItems.forEach(function(item) {
        item.classList.remove('is-open');
      });
    }

    megaItems.forEach(function(item) {
      var link = item.querySelector('.nav-link');

      // Desktop: hover to open
      item.addEventListener('mouseenter', function() {
        if (window.innerWidth > 768) {
          clearTimeout(closeTimeout);
          closeAll();
          item.classList.add('is-open');
        }
      });

      item.addEventListener('mouseleave', function() {
        if (window.innerWidth > 768) {
          closeTimeout = setTimeout(function() {
            item.classList.remove('is-open');
          }, 150);
        }
      });

      // Also handle click for touch devices
      // First click opens mega menu, second click navigates to the page
      if (link) {
        link.addEventListener('click', function(e) {
          if (item.classList.contains('has-mega')) {
            var wasOpen = item.classList.contains('is-open');
            if (wasOpen) {
              // Menu is already open, allow navigation to the href
              return;
            }
            e.preventDefault();
            closeAll();
            item.classList.add('is-open');
          }
        });
      }
    });

    // Close mega menu when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nav-item.has-mega')) {
        closeAll();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAll();
      }
    });

    // Image preview on hover over category links
    document.querySelectorAll('.mega-cat-link[data-img]').forEach(function(catLink) {
      catLink.addEventListener('mouseenter', function() {
        var img = this.getAttribute('data-img');
        var label = this.getAttribute('data-label') || this.querySelector('.mega-cat-name').textContent;
        var panel = this.closest('.mega-menu');
        if (panel) {
          var previewImg = panel.querySelector('.mega-preview-img img');
          var previewLabel = panel.querySelector('.mega-preview-label');
          if (previewImg && img) previewImg.src = img;
          if (previewLabel && label) previewLabel.textContent = label;
        }
      });
    });
  });
})();
